export const Cores = {
  common: {
    orange: "#EE640A",
    primary: "#0069d9",
    secondary: "#5a6268",
    success: "#34c38f",
    danger: "#f46a6a",
    warning: "#f1b44c",
    light: "#eff2f7",
    dark: "#343a40",
  },
  buttons: {
    vermelhoDeny: "#f46a6a",
    cinzaDeny: "#6A6A6A",
    azulConfirm: "#50a5f1",
    verdeConfirm: "#34c38f",
  },
  border: {
    cinzaClaro: "#cecece",
  },
};
